<template>
  <main class="market-view"><v-container><div class="market-head"><div class="eyebrow">Mercado secundario</div><h1>Mové tu inversión<br><em>cuando lo necesites.</em></h1><p>Consultá las órdenes disponibles y encontrá nuevas oportunidades dentro de la comunidad.</p></div><div class="market-note"><v-icon>mdi-shield-check-outline</v-icon><span>Las operaciones están sujetas a disponibilidad y a las condiciones de cada proyecto.</span></div><market-table :orders="projectMarketInfo" /></v-container></main>
</template>
<script>
export default {
  components:{
    MarketTable:()=>import('@/views/marketModule/components/MarketTable.vue')
  },
  data(){
    return {
      projectMarketInfo: []
    }
  },
  mounted(){
    this.$cf_api.getProjectsMarketInfo().then(response=> {
      this.projectMarketInfo = response.data
    })
  }
}
</script>
<style scoped>
.market-view{min-height:calc(100vh - 64px);background:#f8f5ef;padding:55px 0 85px;color:#173347;font-family:Inter,Arial,sans-serif}.eyebrow{color:#d5654c;font-size:10px;font-weight:700;letter-spacing:1.7px;text-transform:uppercase;margin-bottom:13px}.market-head h1{font-family:Georgia,serif;font-size:47px;line-height:1.08;font-weight:400;letter-spacing:-1px;margin:0}.market-head h1 em{color:#e0765b}.market-head p{max-width:510px;color:#667881;font-size:14px;line-height:1.6;margin:14px 0 25px}.market-note{background:#e8eeed;display:flex;gap:9px;align-items:center;padding:12px 15px;margin-bottom:24px;color:#526b6d;font-size:11px}.market-note .v-icon{color:#538176}@media(max-width:600px){.market-view{padding-top:35px}.market-head h1{font-size:39px}}
</style>
